import { useMatchMedia } from "../../../../util/useMatchMedia/useMatchMedia";
import { screenSizeTokens } from "./tokens/screenSizeTokens";

/**
 * A hook that checks if you're on a medium screen size or smaller
 */
export function useIsMediumScreenSize(): boolean {
  return useMatchMedia(screenSizeTokens.$medium.replace("@media ", ""));
}

/**
 * A hook that checks if you're on a small screen size
 */
export function useIsSmallScreenSize(): boolean {
  return useMatchMedia(screenSizeTokens.$small.replace("@media ", ""));
}

/**
 * A hook that checks if you're on a xsmall screen size
 */
export function useIsXsmallScreenSize(): boolean {
  return useMatchMedia(screenSizeTokens.$xsmall.replace("@media ", ""));
}
